import { useTranslation } from "react-i18next";
import { Input } from "@/shared/components/ui/input";
import { Label } from "@/shared/components/ui/label";
import { Button } from "@/shared/components/ui/button";

interface FoundingReportFiltersProps {
  readonly country: string;
  readonly tier: string;
  readonly onCountryChange: (value: string) => void;
  readonly onTierChange: (value: string) => void;
  readonly onReset: () => void;
}

export function FoundingReportFilters({
  country,
  tier,
  onCountryChange,
  onTierChange,
  onReset,
}: FoundingReportFiltersProps) {
  const { t } = useTranslation();
  const canReset = country.trim() !== "" || tier.trim() !== "";

  return (
    <div className="flex flex-wrap items-end gap-3">
      <div className="flex flex-col gap-1">
        <Label htmlFor="founding-country">{t("founding.filters.country")}</Label>
        <Input
          id="founding-country"
          data-testid="founding-filter-country"
          value={country}
          maxLength={8}
          placeholder="US"
          onChange={(e) => onCountryChange(e.target.value)}
          className="w-32"
        />
      </div>
      <div className="flex flex-col gap-1">
        <Label htmlFor="founding-tier">{t("founding.filters.tier")}</Label>
        <Input
          id="founding-tier"
          data-testid="founding-filter-tier"
          value={tier}
          maxLength={64}
          onChange={(e) => onTierChange(e.target.value)}
          className="w-40"
        />
      </div>
      <Button
        type="button"
        variant="ghost"
        data-testid="founding-filter-reset"
        disabled={!canReset}
        onClick={onReset}
      >
        {t("founding.filters.reset")}
      </Button>
    </div>
  );
}
